module.exports = __webpack_public_path__ + "static/img/SmartPlatform2.feb513b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SmartPlatform2.png
// module id = ukPb
// module chunks = 13